import { Dialog } from "primereact/dialog";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { JVDate } from "../../shared/JVDate";
import { useEffect, useRef, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { InputTextarea } from "primereact/inputtextarea";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { JVCheckbox } from "../../shared/JVCheckbox";

interface IProps {
    open: boolean,
    singleData?: IInvoiceTracking,
    toast?: any,
    hideDialog: () => void,
    action: boolean,
    loadTableData: () => void,
    loadTableDataCount: () => void,
    po: IPurchaseOrder,
};

export interface IInvoiceTracking {
    invoice_ID?: number | null,
    invoiceNO?: string | null,
    pO_ID?: number | null,
    consultant_ID?: number | null,
    fromDate?: Date | null,
    toDate?: Date | null,
    invoiceHours?: number | null,
    invoiceRate?: number | null,
    invoiceAmount?: number | null,
    invoiceDate?: Date | null,
    dueDate?: Date | null,
    preparedBy?: number | null,
    verfiedBy?: number | null,
    verifyComment?: string | null,
    invoiceStatus?: string | null,
    paymentStatus?: string | null,
    invoice_Cycle?: string | null,
    payment_Term?: string | null,
    invoicePath?: string | null,
    createdOn?: Date | null,
    createdBy?: number | null,
    updatedOn?: Date | null,
    updatedBy?: number | null,
    verify?: boolean | null,
    balance_Rate?: number | null,
    receivedAmount?: number | null,
    payment_Mode?: string | null,
    transaction_ID?: string | null,
    releasePaymentDate?: Date | string | null,
    releasePaymentType?: number | null,
    isCalculated?: boolean | null,
    payment_Date?: Date | null,
    is_Credit_Note?: boolean
};

const schema = yup.object({

    paymentStatus: yup.string().required("Payment Status is Required"),

    receivedAmount: yup.number().when('paymentStatus', val => {
        return (val !== 'Pending') ? yup.number().required("Balance Rate is required when Payment Status is 'Balance'") : yup.number().nullable()
    }),
    // payment_Mode: yup.number().when('paymentStatus', val => {
    //     return (val !== 'Pending') ? yup.string().required("Payment Mode is Required") : yup.string().nullable()
    // }),
    // transaction_ID: yup.number().when('paymentStatus', val => {
    //     return (val !== 'Pending') ? yup.string().required("Transaction ID is Required") : yup.string().nullable()
    // }),
    payment_Mode: yup.string().nullable(),
    transaction_ID: yup.string().nullable(),
    releasePaymentDate: yup.date().nullable(),
    is_Hold: yup.boolean().nullable(),
    payment_Date: yup.date().required("Payment Date is required").typeError("Payment Date is required"),
});

export const GenerateInvoices = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [uploadedInvoice, setUploadedInvoice] = useState(false);
    const [reason, setReason] = useState("");
    const [verify, setVerify] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<IInvoiceTracking>({
        resolver: yupResolver(schema),
        defaultValues: { ...props.singleData, payment_Date: new Date(props?.singleData?.payment_Date || "") },
        shouldFocusError: false
    });
    const ref = useRef<any>();
    const header = () => {
        return <p>Update Invoices</p>;
    };
    const onHide = () => {
        props.hideDialog();
        setUploadedInvoice(false);
        setReason("");
        setVerify(false);
    };
    const onSubmit = async (data: IInvoiceTracking) => {
        if (data.paymentStatus === "Pending" && (data.receivedAmount || 0) > 0 && (data.payment_Date != null && data.payment_Date != undefined)) {
            props.toast.current.show({ severity: 'error', detail: "Received Amount must be 0 if Payment Status is : Pending", life: 3000 });
        } else if (data.paymentStatus === "Paid" && (data.receivedAmount || 0) !== Number(props.singleData?.invoiceAmount || 0) && data.is_Credit_Note !== true) {
            props.toast.current.show({ severity: 'error', detail: "Received Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else if (data.paymentStatus === "Balance" && (data.receivedAmount || 0) >= Number(props.singleData?.invoiceAmount || 0)) {
            props.toast.current.show({ severity: 'error', detail: "Received Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else if (data.paymentStatus === "Over Payment" && (data.receivedAmount || 0) <= Number(props.singleData?.invoiceAmount || 0)) {
            props.toast.current.show({ severity: 'error', detail: "Received Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else {
            delete data.verify;
            delete data.verfiedBy;

            if (data.paymentStatus === "Pending") {
                data.payment_Date = null;
                data.transaction_ID = null;
                data.payment_Mode = null;
            }

            delete data.invoiceRate;
            setLoading(true);
            const method = (props?.singleData?.invoice_ID != 0 && props?.singleData?.invoice_ID != null) ? "PUT" : "POST";
            // const method = "POST";
            const message = (props.singleData?.invoice_ID != 0 && props.singleData?.invoice_ID != null) ? "Updated Successfully" : "Added Successfully";
            // const message = "Added Successfully";
            if (!(props.singleData?.invoice_ID != 0 && props.singleData?.invoice_ID != null)) {
                delete data.invoice_ID;
            };

            if (props.action === true) {
                data.verifyComment = reason;
            }

            const response = await Fetch("InvoiceTracking/updatePayementStatus", "PUT", data, verify === true ? `hold=${data.isCalculated ? 1 : 0}&verify=1` : `hold=${data.isCalculated ? 1 : 0}`, props.toast);
            if (response) {
                props.loadTableData();
                props.loadTableDataCount();
                props.hideDialog();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                reset({});
            }
            setLoading(false);
        }

    }
    const invoiceUpload = (event: FileUploadHandlerParam) => {
        if (event.files[0].type === "application/pdf") {
            if (event.files[0].size > 1024 * 1024 * 5) {
                // console.log(event.files[0].size);
                props.toast.current.show({ severity: 'error', content: "PDF File should be less than 5 MB." });
                event.options.clear();
            } else {
                uploadeInvoice(event.files[0]);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A PDF File." });
            event.options.clear();
        }
    };
    const uploadeInvoice = async (invoice: File) => {
        let formData = new FormData();
        formData.append("invoice", invoice);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        setLoading(true);
        const response = await fetch(`${baseUrl}InvoiceTracking/invoice`, params);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Invoice Uploaded Successfully." });
            setLoading(false);
            setUploadedInvoice(true);
        } else setLoading(false);
    }


    const Payment_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const Payment_Mode = [
        { name: "-- SELECT --", value: null },
        { name: "Check", value: "CHECK" },
        { name: "NetBanking", value: "NET BANKING" },
        { name: "UPI", value: "UPI" },
        { name: "PayPal", value: "PAYPAL" },
        { name: "Direct Deposit", value: "DIRECT DEPOSIT" },
        { name: "Wire Transfer", value: "WIRE TRANSFER" },
        { name: "ACH", value: "ACH" },
    ];
    const Payment_Release_Status = [
        { name: "Un Paid", value: 1 },
        { name: "Paid", value: 2 },
        { name: "Hold", value: 3 },
    ];

    const selectedPaymentStatus = watch("paymentStatus");

    useEffect(() => {
        if (props.open === true) {
            let newBody: any = props.singleData;
            newBody.payment_Date = new Date(newBody.payment_Date || "");
            reset(newBody);
            if (props.singleData?.invoicePath != null && props.singleData?.invoicePath.trim() != "") {
                setUploadedInvoice(true);
            }
            if (props.singleData?.verify === true) {
                setVerify(true);
                setReason(props.singleData?.verifyComment || "");
            }
        }
    }, [props.open]);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            // if (name === "receivedAmount") {
            //     if (value.receivedAmount != null && value.receivedAmount != undefined && Number(value.receivedAmount) != 0) {
            //         if (Number(value.receivedAmount) < Number(props.singleData?.invoiceAmount || 0)) {
            //             setValue("paymentStatus", "Balance");
            //         } else if (Number(value.receivedAmount) > Number(props.singleData?.invoiceAmount || 0)) {
            //             setValue("paymentStatus", "Over Payment");
            //         } else if (Number(value.receivedAmount) === Number(props.singleData?.invoiceAmount || 0)) {
            //             setValue("paymentStatus", "Paid");
            //         }
            //         // if (value.paymentStatus === "Paid" && value.receivedAmount !== Number(props.singleData?.invoiceAmount || 0)) {
            //         //     if (value.receivedAmount > Number(props.singleData?.invoiceAmount || 0)) {
            //         //         setValue("paymentStatus", "Over Payment");
            //         //     }
            //         //     if (value.receivedAmount < Number(props.singleData?.invoiceAmount || 0)) {
            //         //         setValue("paymentStatus", "Balance");
            //         //     }
            //         // } else if (value.paymentStatus === "Balance") {
            //         //     if (value.receivedAmount === Number(props.singleData?.invoiceAmount || 0)) {
            //         //         setValue("paymentStatus", "Paid");
            //         //     }
            //         //     if (value.receivedAmount > Number(props.singleData?.invoiceAmount || 0)) {
            //         //         setValue("paymentStatus", "Over Payment");
            //         //     }
            //         // } else if (value.paymentStatus === "Over Payment") {
            //         //     if (value.receivedAmount === Number(props.singleData?.invoiceAmount || 0)) {
            //         //         setValue("paymentStatus", "Paid");
            //         //     }
            //         //     if (value.receivedAmount < Number(props.singleData?.invoiceAmount || 0)) {
            //         //         setValue("paymentStatus", "Balance");
            //         //     }
            //         // }
            //     }
            // }
        });
        return () => subscription.unsubscribe();

    }, [watch]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <div className='field col-12 md:col-4'>
                        <label>Invoice Amount</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.singleData?.invoiceAmount}</p>
                    </div>
                    <JVDropdown column={3} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} disabled={props.action} />
                    <JVDate column={3} label="Payment Received Date" control={control} name="payment_Date" error={errors.payment_Date?.message} disabled={props.action} />
                    <JVInput required column={3} label="Received Amount" control={control} name="receivedAmount" error={errors.receivedAmount?.message} />
                    <JVDropdown column={3} label="Payment Mode" control={control} name="payment_Mode" options={Payment_Mode} optionLabel="name" optionValue="value" placeholder="Select Payment Mode" error={errors.payment_Mode?.message} />
                    <JVInput column={3} label="Transaction ID" control={control} name="transaction_ID" error={errors.transaction_ID?.message} />
                    <JVCheckbox column={6} label="Hold Incentive Calculation" control={control} name="isCalculated" />
                    <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6 h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => reset(props.singleData)} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}